import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="connect-status"
//
// Express document-upload screens: after a provider connection succeeds, swap the "Connect …"
// CTA for a "we're pulling your data" message. The argyle / stripe-financial-connections
// controllers dispatch a `connected` event (which bubbles) on success; we listen for it via
//   data-action="argyle:connected->connect-status#connected
//                stripe-financial-connections:connected->connect-status#connected"
// We can't show the imported data in-page (the fetch takes ~a minute), so we just acknowledge the
// connection and tell the member it's happening in the background.
export default class extends Controller {
  static targets = ["cta", "pulling"]

  connected() {
    this.ctaTargets.forEach((el) => el.classList.add("hidden"))
    this.pullingTargets.forEach((el) => el.classList.remove("hidden"))
  }
}
